export default __webpack_public_path__ + "static/media/yelpCamp3.87d02bc5.jpg";